module.exports = __webpack_public_path__ + "static/img/system-1.1afce8fc.png";